import { Link } from 'react-router-dom';
import { Phone } from 'lucide-react';
import { Button } from '../ui/button';

const HowItWorksSection = () => (
  <>
    <section className="py-16 md:py-24 bg-slate-50" data-testid="how-it-works-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-primary mb-4">
            How It Works
          </h2>
          <p className="text-lg text-slate-600">
            Getting started is simple and straightforward.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div className="relative text-center">
            <div className="inline-flex items-center justify-center w-16 h-16 bg-black/10 rounded-full mb-6">
              <span className="font-heading text-2xl font-bold text-primary">01</span>
            </div>
            <div className="hidden md:block absolute top-8 left-[60%] w-[80%] border-t-2 border-dashed border-slate-300"></div>
            <h3 className="font-heading text-xl font-semibold text-primary mb-2">Schedule</h3>
            <p className="text-slate-600">Call or request an appointment online. We respond promptly.</p>
          </div>
          <div className="relative text-center">
            <div className="inline-flex items-center justify-center w-16 h-16 bg-black/10 rounded-full mb-6">
              <span className="font-heading text-2xl font-bold text-primary">02</span>
            </div>
            <div className="hidden md:block absolute top-8 left-[60%] w-[80%] border-t-2 border-dashed border-slate-300"></div>
            <h3 className="font-heading text-xl font-semibold text-primary mb-2">Evaluation</h3>
            <p className="text-slate-600">Thorough, private assessment to understand your concerns.</p>
          </div>
          <div className="relative text-center">
            <div className="inline-flex items-center justify-center w-16 h-16 bg-black/10 rounded-full mb-6">
              <span className="font-heading text-2xl font-bold text-primary">03</span>
            </div>
            <h3 className="font-heading text-xl font-semibold text-primary mb-2">Plan</h3>
            <p className="text-slate-600">Clear diagnosis and personalized treatment options.</p>
          </div>
        </div>
      </div>
    </section>

    <section className="bg-slate-50 py-12 md:py-16" data-testid="team-culture-section">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="rounded-2xl overflow-hidden shadow-lg">
          <img
            src="https://customer-assets.emergentagent.com/job_672d1315-e63e-45a4-b5f9-5a02f895fa2f/artifacts/t5anrewh_IMG_4335.jpg"
            alt="The Havkin Urology family"
            className="w-full h-auto object-cover"
          />
        </div>
        <p className="text-center text-slate-500 mt-4 text-sm font-medium">Our team — We're more than a practice, we're a family.</p>
      </div>
    </section>

    <section className="py-16 md:py-24 bg-black" data-testid="cta-section">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h2 className="font-heading text-3xl md:text-4xl font-bold text-white mb-4">
          Ready to Take the Next Step?
        </h2>
        <p className="text-lg text-gray-300 mb-8 max-w-2xl mx-auto">
          Schedule a confidential consultation today. We're here to help you get answers and a clear plan forward.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Button
            asChild
            size="lg"
            className="bg-white text-black hover:bg-gray-200 rounded-full px-8"
            data-testid="cta-appointment-btn"
          >
            <Link to="/contact">Request Appointment</Link>
          </Button>
          <a
            href="tel:+13215004545"
            className="inline-flex items-center justify-center px-8 py-3 bg-transparent border-2 border-white text-white rounded-full font-medium hover:bg-white/10 transition-colors"
            data-testid="cta-call-btn"
          >
            <Phone className="h-5 w-5 mr-2" />
            Call (321) 500-4545
          </a>
        </div>
      </div>
    </section>
  </>
);

export default HowItWorksSection;
